import { render, staticRenderFns } from "./subject-wrap.vue?vue&type=template&id=6b871487&scoped=true&"
import script from "./subject-wrap.vue?vue&type=script&lang=ts&"
export * from "./subject-wrap.vue?vue&type=script&lang=ts&"
import style0 from "./subject-wrap.vue?vue&type=style&index=0&id=6b871487&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b871487",
  null
  
)

export default component.exports